import BuildingPage from "../BuildingPage";
import PaymentsOut from "./PaymentsOut";
import PaymentsIn from "./PaymentsIn";
import CategoryPage from "./PaymentCategory/list";
import CostCenterPage from "./PaymentCostCenter/list";
import Home from "./Home";

export const paths = [
  {
    path: "/financial/home",
    component: Home, //Home
  },
  {
    path: "/financial/pay-out",
    component: PaymentsOut, //PaymentsOut
  },
  {
    path: "/financial/pay-in",
    component: PaymentsIn, //PaymentsIn
  },
  {
    path: "/financial/categories",
    component: CategoryPage, //CategoryPage
  },
  {
    path: "/financial/cost-centers",
    component: CostCenterPage, // CostCenterPage
  },
  {
    path: "/building-page...",
    component: BuildingPage, //BuildingPage
  },
];
export const FinancialRouters = {
  icon: "wallet",
  path: "",
  label: "Financeiro",
  badge: "beta",
  tree: [
    {
      icon: "home",
      path: "/financial/home",
      label: "Resumo",
    },
    {
      icon: "money-check-alt",
      path: "/financial/pay-out",
      label: "Contas a Pagar",
    },
    {
      icon: "hand-holding-usd",
      path: "/financial/pay-in",
      label: "Contas a Receber",
    },
    {
      icon: "list-alt",
      path: "/financial/categories",
      label: "Categorias",
    },
    {
      icon: "store-alt",
      path: "/financial/cost-centers",
      label: "Centros de Custo",
    },
    // {
    //   icon: "file-invoice-dollar",
    //   path: "/building-page...",
    //   label: "Antecipar Boleto",
    // },
    // {
    //   icon: "tags",
    //   path: "/building-page...",
    //   label: "Concilicação Bancária",
    // },
  ],
};



// WEBPACK FOOTER //
// ./src/views/AppViews/Financial/routers.jsx